import { ICityWithTowns } from "../models/ICityList";
import { configWithWebToken } from "./config";

export const getCityListPublic = () =>
  configWithWebToken.get<ICityWithTowns[]>("City/CityList");
